import React from 'react';

import { Divider } from 'ui-components/components/divider';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { ContactDetailsFieldIds } from './contact-details-field-ids';
import { ContactDetailsInputField } from './contact-details-input-field';
import { FbsApplicationDrawerSection } from '../fbs-application-drawer-section';
import styles from './contact-details-section.module.less';
import { messages } from './messages';

/**
 * @param {object} props
 * @param {object} props.contactDetails - The contact details state
 * @param {(field: string, event: Event) => void} props.onContactDetailChange - Handler for contact detail changes
 * @param {boolean} props.isDisabled
 * @returns {JSX.Element} The contact details section component
 */
export const ContactDetailsSection = ({ contactDetails, onContactDetailChange, isDisabled }) => {
  return (
    <FbsApplicationDrawerSection headerMessageDescriptor={messages.contactDetailsTitle} isDisabled={isDisabled}>
      <FlexColumn gap={Gap.Space24}>
        <FlexColumn gap={Gap.Space16}>
          <Text textType={TextType.H4} value={messages.contactDetailsDescription} />
          <div className={styles['contact-form-row']}>
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.FirstName}
              labelMessageDescriptor={messages.firstName}
              onContactDetailChange={onContactDetailChange}
              value={contactDetails[ContactDetailsFieldIds.FirstName]}
            />
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.LastName}
              labelMessageDescriptor={messages.lastName}
              onContactDetailChange={onContactDetailChange}
              value={contactDetails[ContactDetailsFieldIds.LastName]}
            />
          </div>
          <div className={styles['contact-form-row']}>
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.ShipstationEmail}
              labelMessageDescriptor={messages.shipstationEmail}
              onContactDetailChange={onContactDetailChange}
              type='email'
              value={contactDetails[ContactDetailsFieldIds.ShipstationEmail]}
            />
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.AlternateEmail}
              isOptional
              labelMessageDescriptor={messages.alternateEmail}
              onContactDetailChange={onContactDetailChange}
              type='email'
              value={contactDetails[ContactDetailsFieldIds.AlternateEmail]}
            />
          </div>
          <div className={styles['contact-form-row']}>
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.Company}
              labelMessageDescriptor={messages.company}
              onContactDetailChange={onContactDetailChange}
              value={contactDetails[ContactDetailsFieldIds.Company]}
            />
            <ContactDetailsInputField
              fieldId={ContactDetailsFieldIds.Phone}
              inputClassName={styles['phone-input']}
              labelMessageDescriptor={messages.phone}
              onContactDetailChange={onContactDetailChange}
              type='tel'
              value={contactDetails[ContactDetailsFieldIds.Phone]}
            />
          </div>
        </FlexColumn>
        <Divider className={styles.divider} />
        <FlexColumn gap={Gap.Space16}>
          <Text element='label' htmlFor={ContactDetailsFieldIds.AdditionalInfo} textType={TextType.H4} value={messages.additionalInfo} />
          <textarea
            className={styles['additional-info-textarea']}
            id={ContactDetailsFieldIds.AdditionalInfo}
            onChange={(event) => onContactDetailChange(ContactDetailsFieldIds.AdditionalInfo, event)}
            rows={4}
            value={contactDetails[ContactDetailsFieldIds.AdditionalInfo]}
          />
        </FlexColumn>
      </FlexColumn>
    </FbsApplicationDrawerSection>
  );
};
